// @flow
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AssetModel from 'Stores/AssetModel';
import classNames from 'classnames/bind';
import styles from './styles.scss';
import FocusedImage from 'Components/FocusedImage';
import Modal from 'Components/Modal';
import Icon from 'Components/Icon';
import { Container, Row, Col } from 'Components/Grid';

const cx = classNames.bind(styles);

const Gallery = ({ images, fullsize, openImageInModal }) => {
  const [openImageSrc, setOpenImageSrc] = useState('');

  const imagesPerRow = 3;
  // creates rows consisting of three images
  const rows = images.reduce((rows, key, index) => {
    if (index % imagesPerRow === 0) {
      rows.push([key]);
    } else {
      rows[rows.length - 1].push(key);
    }

    return rows;
  }, []);

  return (
    <div
      className={cx('grid', {
        fullsize,
      })}
    >
      <Modal isOpen={openImageSrc !== ''} onClose={() => setOpenImageSrc('')}>
        <Container>
          <Row>
            <Col align="center">
              <img src={openImageSrc} role="presentation" />
            </Col>
          </Row>
        </Container>
      </Modal>

      {rows.map((items, i) => (
        <div key={`row-${i}`} className={styles.row}>
          <div className={styles.rowContainer}>
            {items.map((item) => (
              <div
                className={styles.gridEl}
                key={`image-${item.id}`}
                onClick={() => openImageInModal && setOpenImageSrc(item.src)}
                role="presentation"
                tabIndex="-1"
                aria-hidden="true"
              >
                <div className={styles.wrapper}>
                  <div className={styles.image}>
                    <FocusedImage image={new AssetModel(item)} />

                    {openImageInModal && (
                      <div className={cx(styles.zoomButton)}>
                        <Icon name="zoom" />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

Gallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.object),
  fullsize: PropTypes.bool,
};

export default Gallery;
